import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { ClipboardCheck } from "lucide-react";
import WeeklySummaryPanel from "../components/WeeklySummaryPanel";

export default function MyTasksPage() {
    const { user } = useAuth();
    const [summary, setSummary] = useState(null);

    useEffect(() => {
        api.get("/dashboard/summary?scope=mine")
            .then((r) => setSummary(r.data))
            .catch((e) => toast.error(formatApiError(e)));
    }, []);

    return (
        <div className="space-y-10" data-testid="my-tasks-page">
            <div>
                <div className="label-caps flex items-center gap-2"><ClipboardCheck size={14} /> Vista pessoal</div>
                <h1 className="font-display text-5xl text-[#0d1628] mt-4">Os meus afazeres</h1>
                <p className="text-[#52525b] mt-4 max-w-2xl">
                    Olá {user?.name?.split(" ")[0]}. Estas são as suas tarefas e sessões para os próximos 7 dias.
                </p>
            </div>

            <WeeklySummaryPanel
                summary={summary}
                title="Esta semana"
                subtitle="Apenas as suas tarefas atribuídas e sessões em que participa"
            />
        </div>
    );
}
